"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordLogbookService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordLogbookService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordLogbookService.instance) {
      return CordLogbookService.instance;
    }
    super();
    this.applicationId = '';
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordLogbookService.instance = this;
  }
  getLogBook(queryObj, applicationId = this.applicationId) {
    return this.post('logbook/' + applicationId, queryObj);
  }
}
exports.CordLogbookService = CordLogbookService;
CordLogbookService.instance = null;
